import { createSelector } from '@ngrx/store';
import { getVehicleDiagnosticsState } from '../reducers';
import * as fromEngineLight from '../reducers/vehicle-diagnostics.reducer';
import { EngineLightChart } from '../../components';
import { milCodeList } from '../../models/mil-code.list';
import { Dtc, ShortDtc } from '../../models/dtc';

export const getDtcList = () =>
  createSelector(getVehicleDiagnosticsState, fromEngineLight.getDtcListState);
export const getDtcListLoading = () =>
  createSelector(getVehicleDiagnosticsState, fromEngineLight.getDtcListLoading);
export const getActiveLampDtc = () =>
  createSelector(getVehicleDiagnosticsState, fromEngineLight.getActiveLampDtc);

export const getMilStatus = () =>
  createSelector(getVehicleDiagnosticsState, fromEngineLight.getMilStatus);

export const getTooltipDtcCodes = () =>
  createSelector(getVehicleDiagnosticsState, fromEngineLight.getTooltipDtc);
export const getTooltipMilStatus = () =>
  createSelector(
    getVehicleDiagnosticsState,
    fromEngineLight.getTooltipMilStatus,
  );

export const getEngineLightsChartData = () =>
  createSelector(getDtcList(), (dtcList): EngineLightChart[] => {
    const chartDtcList: EngineLightChart[] = [];

    dtcList.forEach((dtc: ShortDtc) => {
      const currentDtc = chartDtcList.find((c) => c.code === dtc.code);

      if (currentDtc) {
        currentDtc.durations.push(dtc.duration);
      } else {
        chartDtcList.push({
          code: dtc.code,
          durations: [dtc.duration],
        });
      }
    });

    return chartDtcList;
  });

export const getActiveDtc = () =>
  createSelector(getMilStatus(), getActiveLampDtc(), (mil, dtcList): Dtc => {
    const milStatuses = milCodeList.filter((item) => item.mil === mil)[0];
    return {
      ...milStatuses,
      codes: dtcList,
    };
  });
export const getActiveLampLoading = () =>
  createSelector(
    getVehicleDiagnosticsState,
    fromEngineLight.getActiveLampLoading,
  );
export const getMilLoading = () =>
  createSelector(getVehicleDiagnosticsState, fromEngineLight.getMilLoading);

export const getActiveDtcLoading = () =>
  createSelector(
    getActiveLampLoading(),
    getMilLoading(),
    (activeLampLoading, milLoading) => activeLampLoading || milLoading,
  );

export const getDtcTooltip = () =>
  createSelector(
    getTooltipDtcCodes(),
    getTooltipMilStatus(),
    (dtc: ShortDtc[], mil): Dtc => {
      const milStatuses = milCodeList.filter((item) => item.mil === mil)[0];
      return {
        ...milStatuses,
        codes: dtc,
      };
    },
  );

export const dtcTooltipLoading = () =>
  createSelector(getVehicleDiagnosticsState, fromEngineLight.getTooltipLoading);
